import React, { Component } from 'react';
import { connect } from 'react-redux';
import { notification } from 'antd';
import MobileSideBar from './mobile/m-sideBar';
import DesktopSideBar from './desktop/sideBar';
import * as TherapistActions from '../../actions/therapist';
import { isMobile } from "react-device-detect";


class Sidebar extends Component {
	constructor(props) {
		super(props);
		this.formInterval = undefined;
		this.changeCallStatus = this.changeCallStatus.bind(this);
	}

	componentDidMount(){
		const { dispatch } = this.props;
		this.formInterval = setInterval(() => {
			dispatch(TherapistActions.getActiveCallHistory());
		}, 30000)
	}

	changeCallStatus( status, callId ){
		const { dispatch, therapists } = this.props;
		const { activeCallHistory } = therapists;
		let activeCallFlag = false;
		activeCallHistory.forEach(activeCall => {
			if(activeCall.callStatus.toLowerCase() === "on call"){
				activeCallFlag = true;
			}
		});
		if(status === "On Call"){
			// let noActiveCall = true;
			// activeCallHistory.forEach(call => {
			// 	if(call.callStatus.toLowerCase() === "on call"){
			// 		noActiveCall = false;
			// 	}
			// });
			// if(!noActiveCall){
			// 	notification['error']({
			// 		message: 'Error',
			// 		description: 'Please end an ongoing call',
			// 	});
			// 	return;
			// }
			if(!window.localStorage.getItem("therapistCallId")){
				window.localStorage.setItem("therapistCallId", callId);
			}
		}else if(status === "End Call"){
			if(!activeCallFlag){
				window.localStorage.removeItem("therapistCallId");
				window.sessionStorage.removeItem("twilioTherapistToken");
				window.sessionStorage.setItem('therapistConnecting', "no");
			}
		}
		dispatch(TherapistActions.changeCallStatus({callId, status}));
		if(status === "On Call"){
			if(!activeCallFlag){
				window.sessionStorage.setItem('therapistConnecting', "no");
				dispatch(TherapistActions.updateCallTimeStatus({status : "start"}))
			}else{
				
			}
			dispatch(TherapistActions.getCurrentActiveCallDetails({callId}));
		}
	} 


	render() {
		if(isMobile){
			return <MobileSideBar key="1" {...this.props} 
									changeCallStatus={this.changeCallStatus} />
		}else{
			return <DesktopSideBar key="1" {...this.props}
									changeCallStatus={this.changeCallStatus} />
		}
	}
}

export default connect(
	state => state
)(Sidebar);
